import { graphql, useStaticQuery } from 'gatsby'

export const useNavigationQuery = () => {
  return useStaticQuery(graphql`
      query Navigations {
          contentfulComponentNavigationFooter {
              companyNavigation {
                  id
                  name
                  slug
                  ...pageRefDatas
                  ...SubNavigationsRecursive
              }
              profilNavigation {
                  id
                  name
                  slug
                  ...pageRefDatas
                  ...SubNavigationsRecursive
              }
              footerLinks {
                  id
                  label
                  url
              }
          }
      }

      fragment pageRefDatas on ContentfulComponentNavigationItem {
          pageReference {
              ... on ContentfulTemplatePageGovernance {
                id
                slug
              }
              ... on ContentfulPageInvestors {
                id
                slug
              }
              ... on ContentfulPageListNews {
                id
                slug
              }
              ... on ContentfulPageRequestDocument {
                id
                slug
              }
              ... on ContentfulPageStockInformation {
                id
                slug
              }
               ... on ContentfulTemplateBasicPage {
                id
                slug
              }
              ... on ContentfulTemplateOurProducts {
                id
                slug
              }
              ... on ContentfulTemplatePageCareers {
                id
                slug
              }
              ... on ContentfulTemplatePageFinancial {
                id
                slug
              }
              ... on ContentfulTemplatePageInnovation {
                id
                slug
              }
              ... on ContentfulTemplatePageLeadership {
                id
                slug
              }
              ... on ContentfulTemplatePageRegister {
                id
                slug
              }
               ... on ContentfulTemplatePageWithBanner {
                id
                slug
              }
              ... on ContentfulTemplateProduct {
                id
                slug
              }
              ... on ContentfulTemplateSustainabilityPage {
                id
                slug
              }
              ... on ContentfulTemplateMediaCenter {
                  id
                  slug
              }
          }

      }

      fragment subNavigations on ContentfulComponentNavigationItem {
          id
          name
          slug
          ...pageRefDatas
      }

      fragment SubNavigationsRecursive on ContentfulComponentNavigationItem {
          subNavigationItems {
              id
              ...subNavigations
              subNavigationItems {
                  id
                  ...subNavigations
                  subNavigationItems {
                      id
                      ...subNavigations
                  }
              }
          }
      }
  `)

}
